<template>
  <div style="width: 100%;height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);width: 100%;overflow-y: auto">
      <el-row style="height: 100%;">
        <el-col :span="4" style="height: 100%;overflow-y: auto;padding-left: 20px;box-sizing: border-box">
          <tree-data ref="tree" @checkChange="checkChange"></tree-data>
        </el-col>
        <el-col :span="20" style="height: 100%;overflow-y: auto;padding-left: 20px;box-sizing: border-box">
          <div style="height: 50px">
            <el-button type="primary" plain icon="el-icon-plus" @click="addRelation()">新增</el-button>&nbsp;&nbsp;
            <el-input prefix-icon="el-icon-search" placeholder="按电话、地址搜索" v-model="searchKeyword1" style="width: 300px" clearable></el-input>
            <el-button type="primary" plain @click="searchWord()">搜索</el-button>
          </div>
          <div style="max-height: calc(100% - 100px);overflow-y: auto;">
            <el-table
              v-loading="loading"
              :data="tbdata"
              border
              style="width: 100%"
              highlight-current-row
              ref="singleTable">
              <el-table-column
                type="index"
                label="序号"
                width="50"
              align="center">
              </el-table-column>
              <el-table-column
                prop="address"
                label="房号"
                min-width="85"
                align="left">
              </el-table-column>
              <el-table-column
                v-if="moduletag === 1"
                label="所属小区"
                min-width="80"
                align="center">
                <template slot-scope="scope">
                  <span>{{getOnCommunity(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                v-else-if="moduletag === 2"
                label="所属机构"
                min-width="80"
                align="center">
                <template slot-scope="scope">
                  <span>{{getOnCommunity(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                v-else
                label="所属小区/机构"
                min-width="80"
                align="center">
                <template slot-scope="scope">
                  <span>{{getOnCommunity(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="联系方式"
                min-width="80"
                align="center">
                <template slot-scope="scope">
                  <span>{{getTelephone(scope.row.telephone)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="所属组织"
                min-width="80"
                align="center">
                <template slot-scope="scope">
                  <span>{{getOnOrg(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="createtime"
                label="录入时间"
                min-width="110"
                align="center">
              </el-table-column>
              <el-table-column align="center" label="操作" width="120">
                <template slot-scope="scope">
                  <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editRelation(scope.row)"></i>
                  <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delRelation(scope.row)"></i>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 10px;height: 40px;text-align: center">
            <el-pagination v-fixZoom
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalCells">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--created-->
    <el-dialog :visible.sync="addShow" v-if="addShow" width="800px"
      :show-close="true" :close-on-click-modal="false" center top="10vh" class="all-open">
      <relation-add :homeAddRow="addRow" v-model="addShow"></relation-add>
    </el-dialog>
    <!--update-->
    <el-dialog :visible.sync="editShow" v-if="editShow" width="800px"
      :show-close="true" :close-on-click-modal="false" center top="10vh" class="all-open">
      <div class="title-top-alarm">
        <div><span>{{editHomeTitle}}</span></div>
        <div class="line-title"></div>
      </div>
      <relation-edit :relationEditRow="editRow" v-model="editShow"></relation-edit>
    </el-dialog>
  </div>
</template>

<script>
import {queryorghome, deleteorghome} from '../../api/relation'
import {queryorgcommunity} from '../../api/community'
import relationAdd from './childComponents/relationAdd'
import relationEdit from './childComponents/relationEdit'
import familyOldPerson from './childComponents/familyOldPerson'
import treeData from '../treeData/treeData.vue'
export default {
  name: 'homeManagement',
  components: {treeData, relationAdd, relationEdit, familyOldPerson},
  data () {
    return {
      isShangHai: true,
      orgid: '',
      // 左边
      orgData: [],
      isFirst: [],
      // 右边
      searchKeyword1: '',
      searchKeyword: '',
      tableData: [],
      showTable: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      orgcommunitys: [],
      // 弹窗
      addShow: false,
      addRow: {
        homeTitle: '',
        cid: '',
        orgcommunitys: [],
        orgid: '',
        orgids: [],
        orgTree: [],
        // row为小区查看家庭小区信息
        row: '',
        isAll: true
      },
      editHomeTitle: '',
      editShow: false,
      editRow: {
        orgcommunitys: [],
        row: {},
        orgTree: []
      },
      moduletag: ''
    }
  },
  created () {
    this.golobleObject.updateTableHome = this.getCommunityTable
    this.isShangHai = this.$store.state.user.isShangHai
    this.moduletag = this.$store.state.user.moduletag
    this.orgid = this.$store.state.user.orgid
  },
  computed: {
    tbdata () {
      return this.searchFilterWord()
    }
  },
  methods: {
    checkChange (obj) {
      if (obj.type === 'check') {
        this.isFirst = obj.orgids
        this.currentPage = 1
        this.addRow.orgids = this.isFirst
        this.getEndTable()
      } else if (obj.type === 'data') {
        this.orgData = obj.orgData
        this.addRow.orgTree = obj.orgData
        this.editRow.orgTree = obj.treeData
        this.getCommunityTable()
      }
    },
    // 所属小区
    getCommunityTable () {
      this.loading = true
      queryorgcommunity().then(res => {
        this.orgcommunitys = res.data.orgcommunitys
        this.addRow.orgcommunitys = res.data.orgcommunitys
        this.editRow.orgcommunitys = res.data.orgcommunitys
        this.getQueryOrgHome()
      }).catch(() => {
        this.loading = false
        this.getQueryOrgHome()
      })
    },
    // 表格数据
    getQueryOrgHome () {
      queryorghome().then(res => {
        let isTime = res.data.orghomes.length / this.pageSize
        if (isTime !== parseInt(isTime)) {
          isTime = parseInt(isTime) + 1
        }
        if (isTime < this.currentPage) {
          if (this.currentPage !== 1) {
            this.currentPage -= 1
          }
        }
        this.tableData = res.data.orghomes
        this.getEndTable()
        // this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getEndTable () {
      this.loading = false
      this.showTable = []
      if (this.isFirst.length === 0) {
        this.showTable = this.tableData
      } else {
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.isFirst.indexOf(this.tableData[i].orgid) > -1) {
            this.showTable.push(this.tableData[i])
          }
        }
      }
    },
    searchWord () {
      this.currentPage = 1
      this.searchKeyword = this.searchKeyword1
    },
    // table数据入口（tbdata）
    searchFilterWord () {
      const data = this.showTable
      const vm = this
      const search = data.filter((val) => {
        if (val.telephone.includes(vm.searchKeyword) || val.address.includes(vm.searchKeyword)) {
          return true
        }
      })
      vm.totalCells = search.length
      const arr = []
      for (let i = (vm.currentPage - 1) * vm.pageSize; i < vm.currentPage * vm.pageSize; i++) {
        if (!search[i]) {
          break
        }
        arr.push(search[i])
      }
      return arr
    },
    getTelephone (phone) {
      if (phone === '<nil>') {
        return ''
      } else {
        return phone
      }
    },
    getOnOrg (row) {
      for (let i = 0; i < this.orgData.length; i++) {
        if (row.orgid === this.orgData[i].id) {
          return this.orgData[i].name
        }
      }
    },
    getOnCommunity (row) {
      for (let i = 0; i < this.orgcommunitys.length; i++) {
        if (row.cid === this.orgcommunitys[i].id) {
          return this.orgcommunitys[i].name
        }
      }
    },
    // 编辑家庭
    editRelation (row) {
      if (this.moduletag === 1) {
        this.editHomeTitle = '更新家庭'
      } else if (this.moduletag === 2) {
        this.editHomeTitle = '更新房间'
      } else {
        this.editHomeTitle = '更新家庭/房间'
      }
      this.editRow.row = row
      this.editShow = true
    },
    // 新建家庭
    addRelation () {
      if (this.moduletag === 1) {
        this.addRow.homeTitle = '新建家庭'
      } else if (this.moduletag === 2) {
        this.addRow.homeTitle = '新建房间'
      } else {
        this.addRow.homeTitle = '新建家庭/房间'
      }
      this.addShow = true
    },
    // 删除关系
    delRelation (row) {
      let name = ''
      if (this.moduletag === 1) {
        name = '家庭'
      } else if (this.moduletag === 2) {
        name = '房间'
      } else {
        name = '家庭/房间'
      }
      this.$confirm('此操作将永久删除该' + name + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          homeids: [row.id]
        }
        deleteorghome(data).then(() => {
          this.getQueryOrgHome()
          this.$notify({
            title: '成功',
            message: '删除家庭成功',
            type: 'success',
            duration: 2000
          })
        }).catch(() => {
          this.$notify.error({
            title: '失败',
            message: '删除家庭失败'
          })
        })
      }).catch(() => {})
    },
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/homeManagement.vue